import has from '@dojo/framework/core/has';
import { create, tsx } from '@dojo/framework/core/vdom';
import * as commonCss from '../../Common.m.css';
import * as css from './BlogList.m.css';
import block from '@dojo/framework/core/middleware/block';
import getBlogPreviews from '../../blocks/wp-blog-previews.block';
import { RenderResult } from '@dojo/framework/core/interfaces';
import { Link } from '@dojo/framework/routing/Link';
import { BlogListSidePane } from '../BlogListSidePane';
import { BlogPreviewList } from '../BlogPreviewList';
import { Head } from '../Head';

export interface BlogListProperties {
	page: number;
}

const factory = create({ block }).properties<BlogListProperties>();

const isDev = Boolean(has('local'));

export const BlogList = factory(function BlogList({ properties, middleware: { block } }) {
	const { page } = properties();
	const previews = block(getBlogPreviews)(20, page, {}, isDev);

	let pagination: RenderResult | undefined;

	if (previews) {
		const { currentPage, totalPages } = previews;

		pagination = (
			<nav>
				{currentPage > 1 && (
					<Link
						classes={css.paginationLink}
						to="blogPage"
						params={{ slugOrPage: `${currentPage - 1}` }}
					>
						{`<< Previous`}
					</Link>
				)}
				{currentPage < totalPages && (
					<Link
						classes={css.paginationLink}
						to="blogPage"
						params={{ slugOrPage: `${currentPage + 1}` }}
					>
						{`Next >>`}
					</Link>
				)}
			</nav>
		);
	}

	return (
		<div classes={css.root}>
			<Head
				title="Development and JavaScript Blog | SitePen"
				description="The SitePen blog gives educational tips for solving big business problems and achieving technical objectives."
			/>
			<div classes={css.spacer}></div>
			<div classes={commonCss.contentWrapper}>
				<section classes={css.content}>
					<div classes={css.leading}>
						{previews && <BlogPreviewList previews={previews.blogPreviews} />}
						{pagination}
					</div>
					<div classes={css.trailing}>
						<BlogListSidePane />
					</div>
				</section>
			</div>
		</div>
	);
});

export default BlogList;
